// QR Kiosk v2 — offline detection writer (KV2-5 / GAP-0). Seeds state.kioskV2.offline
// from navigator.onLine on mount, then flips it on the window online/offline events.
// Called ONCE from KioskV2Layout (never per page). The cleanup resets offline=false so
// a stale flag can never leak into a future mount.
//
// navigator.onLine is a HINT, not truth — a server outage with the LAN up never flips
// it. That is exactly why the §5 surface decision tree works off fetch RESULTS while
// this strip works off the browser flag: two independent layers that may co-appear.
import { useEffect } from "react";
import { useAppDispatch } from "../../../shared/hooks/sharedHooks";
import { setOffline } from "../kioskV2Slice";

export function useOfflineListener(): void {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setOffline(!navigator.onLine)); // initial state on mount
    const on = () => dispatch(setOffline(false));
    const off = () => dispatch(setOffline(true));
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      dispatch(setOffline(false));
    };
  }, [dispatch]);
}

export default useOfflineListener;
